import { useNavigate } from "react-router";

import { useListDataWithLoadMore } from "../../../hooks";
import { GET_SC_USERS } from "../../../graphql/queries";
import { parseScPatients } from "../../../graphql/utils";
import {
  PatientsScProps,
  PatientScPage as Component,
} from "../../../components/pages/patientSc/PatientScPage";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const PatientScPage = () => {
  const navigate = useNavigate();
  useCheckUserRole();

  const {
    data,
    variables: { keyword, order },
    handlers: { onSearchClick, onResetClick, onSortClick, onLoadMoreClick },
  } = useListDataWithLoadMore(
    GET_SC_USERS,
    "scUsers",
    "処方情報は全て表示されています",
  );

  if (!data?.scUsers) {
    return null;
  }

  const props: PatientsScProps = {
    patients: parseScPatients(data.scUsers),
    searchValue: keyword,
    order,
    onSearchClick,
    onResetClick,
    onSortClick,
    onRowClick: (patientId: string) => navigate(`/patient/${patientId}`),
    onLoadMoreClick,
  };

  return <Component {...props} />;
};
